export type CourseStatus = {
  isFinished: boolean;
  hasAlreadyFollowed: boolean;
  notStarted: boolean;
  isFollowing: boolean;
};

type CourseLike = {
  userCourseCompletionRate?: number | null;
  userHasFollowedCourse?: boolean;
  userIsFollowingCourse?: boolean;
};

export default function useCourseStatus(course: CourseLike): CourseStatus {
  const progression = course?.userCourseCompletionRate ?? null;
  const userHasFollowedCourse = Boolean(course?.userHasFollowedCourse);
  const userIsFollowingCourse = Boolean(course?.userIsFollowingCourse);

  const isFinished = progression === 100;
  const hasAlreadyFollowed = !isFinished && userHasFollowedCourse && !userIsFollowingCourse;
  const notStarted = !isFinished && !userHasFollowedCourse && !userIsFollowingCourse;
  const isFollowing = !isFinished && userIsFollowingCourse;

  return { isFinished, hasAlreadyFollowed, notStarted, isFollowing };
}
